import { IRequestsState } from './types';

export const getRequestsStateInitial = (
): IRequestsState => ({
    boards: {},
    cards: {},
    dependencies: {},
});
